import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'
import { URL_ROOT, URL_ACCOUNT_LOGIN } from '@/consts/urls'

import AuthentificationService from '@/services/authentification'

Vue.use(VueRouter)

function scrollBehavior(to, from, savedPosition) {
  return savedPosition || { x: 0, y: 0 }
}

const routingBase = `/${document.documentElement.lang}/`

const router = new VueRouter({
  mode: 'history',
  base: routingBase,
  routes,
  scrollBehavior
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.authenticated && !AuthentificationService.getUserIsLogged()) {
    return next({
      name: URL_ACCOUNT_LOGIN,
      query: {
        returnPath: to.fullPath
      }
    })
  } else if (to.meta.anonymous && AuthentificationService.getUserIsLogged()) {
    return next({
      name: URL_ROOT
    })
  }

  next()
})

export default router
